import { ComumService } from '../../comum/comum.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Endereco } from './../../comum/modelos/endereco';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Telefone } from './../../comum/modelos/telefone';
import { TelefoneUsuario } from '../../comum/modelos/telefone-usuario';
import { EnderecoUsuario } from '../../comum/modelos/endereco-usuario';
import { Usuario } from '../../comum/modelos/usuario';
import { UsuarioService } from './../usuario.service';
import { AuthService } from '../../auth/auth.service';
import { ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/core';
import { AreaCliente } from '../../comum/modelos/area-cliente';
import { ClienteService } from '../../cliente/cliente.service';

@Component({
    selector: 'app-cadastro-usuario',
    templateUrl: './cadastro-usuario.component.html',
    styleUrls: ['./cadastro-usuario.component.css']
})
export class CadastroUsuarioComponent implements OnInit {

    private CADASTRAR = 'Cadastrar';
    private ATUALIZAR = 'Atualizar';
    private MODO: string;

    public usuario: Usuario;
    public foto: File;
    public telefonesUsuarioRemovidos: TelefoneUsuario[];
    public enderecosUsuarioRemovidos: EnderecoUsuario[];
    public telefonesUsuarioInseridos: TelefoneUsuario[];
    public enderecosUsuarioInseridos: EnderecoUsuario[];
    public telefonesUsuarioAtualizados: TelefoneUsuario[];
    public enderecosUsuarioAtualizados: EnderecoUsuario[];
    public areasCliente: AreaCliente[];

    public paginacaoTelefone: Paginacao;
    public paginacaoEndereco: Paginacao;
    public loading = false;
    public statusCode: number;

    constructor (private _usuarioService: UsuarioService,
        private _comumService: ComumService,
        private _authService: AuthService,
        private _clienteService: ClienteService,
        private _activatedRoute: ActivatedRoute,
        private router: Router,
        private confirmationService: ConfirmationService,
        private _cookieService: CookieService) {
        this.usuario = new Usuario();
        this.paginacaoTelefone = new Paginacao();
        this.paginacaoEndereco = new Paginacao();

        this.paginacaoTelefone.itens = 3;
        this.paginacaoTelefone.page = 1;
        this.paginacaoTelefone.id = 'telefone';

        this.paginacaoEndereco.itens = 3;
        this.paginacaoEndereco.page = 1;
        this.paginacaoEndereco.id = 'endereco';

        this.telefonesUsuarioRemovidos = new Array<TelefoneUsuario>();
        this.enderecosUsuarioRemovidos = new Array<EnderecoUsuario>();
        this.telefonesUsuarioInseridos = new Array<TelefoneUsuario>();
        this.enderecosUsuarioInseridos = new Array<EnderecoUsuario>();
        this.telefonesUsuarioAtualizados = new Array<TelefoneUsuario>();
        this.enderecosUsuarioAtualizados = new Array<EnderecoUsuario>();
        this.areasCliente = new Array<AreaCliente>();
    }

    ngOnInit() {
        const id = this._activatedRoute.snapshot.params['id'];
        this.loading = true;

        if (id !== undefined) {
            this._usuarioService.obterUsuarioPorIdHttp(id)
                .subscribe((usuario: Usuario) => {
                    this.usuario = usuario;
                    this.MODO = this.ATUALIZAR;
                    this._clienteService.obterAreasClienteHttp(parseInt(
                        this._cookieService.get('idCliente'), 10)).subscribe(areasCliente => {
                            this.areasCliente = areasCliente;
                            this.loading = false;
                        });
                });
        } else {
            this.MODO = this.CADASTRAR;
            this.usuario.idCliente = parseInt(this._cookieService.get('idCliente'), 10);
            this._clienteService.obterAreasClienteHttp(parseInt(this._cookieService.get('idCliente'), 10)).subscribe(areasCliente => {
                this.areasCliente = areasCliente;
                this.loading = false;
            });
        }

    }

    onSubmit(): void {
        this.loading = true;
        const self = this;

        if (self.MODO === self.CADASTRAR) {
            self._authService.signUpWithEmail(self.usuario.email, self.usuario.senha).then(() => {
                self.usuario.uid = self._authService.authState.uid;
                self._usuarioService.cadastrarUsuarioHttp(self.usuario, self.foto)
                    .subscribe(response => {
                        self.loading = false;
                        self.statusCode = response.status;
                        self._comumService.evento.cadastro = true;
                        self.router.navigate(['listar-usuarios']);
                    }, errorCode => {
                        self.statusCode = errorCode;
                        self.loading = false;
                    });
            }).catch(_error => {
                self.loading = false;
                self.confirmationService.confirm({
                    rejectVisible: false,
                    message: 'E-mail/senha inv\u00e1lidos.',
                    accept: () => { },
                    reject: () => {
                    }
                });
            });
        } else {
            self.processarTelefonesUsuario();
            self.processarEnderecosUsuario();
            self._usuarioService.atualizarUsuarioHttp(self.usuario, self.foto)
                .subscribe(response => {
                    self.loading = false;
                    self.statusCode = response.status;
                    self._comumService.evento.cadastro = true;
                    self.router.navigate(['listar-usuarios']);
                }, errorCode => {
                    self.statusCode = errorCode;
                    self.loading = false;
                });
        }
    }

    processarTelefonesUsuario(): void {
        this.usuario.telefonesUsuario.forEach(telefoneUsuario => {
            if (telefoneUsuario.alterado) {
                if (telefoneUsuario.idTelefoneUsuario === undefined) {
                    telefoneUsuario.idUsuario = this.usuario.idUsuario;
                    this.telefonesUsuarioInseridos.push(telefoneUsuario);
                } else {
                    this.telefonesUsuarioAtualizados.push(telefoneUsuario);
                }
            }
        });

        if (this.telefonesUsuarioRemovidos.length > 0) {
            this._usuarioService.removerTelefonesUsuarioHttp(this.telefonesUsuarioRemovidos)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }

        if (this.telefonesUsuarioInseridos.length > 0) {
            this._usuarioService.cadastrarTelefonesUsuarioHttp(this.telefonesUsuarioInseridos)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }

        if (this.telefonesUsuarioAtualizados.length > 0) {
            this._usuarioService.atualizarTelefonesUsuarioHttp(this.telefonesUsuarioAtualizados)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }
    }

    processarEnderecosUsuario(): void {
        this.usuario.enderecosUsuario.forEach(enderecoUsuario => {
            if (enderecoUsuario.alterado) {
                if (enderecoUsuario.idEnderecoUsuario === undefined) {
                    enderecoUsuario.idUsuario = this.usuario.idUsuario;
                    this.enderecosUsuarioInseridos.push(enderecoUsuario);
                } else {
                    this.enderecosUsuarioAtualizados.push(enderecoUsuario);
                }
            }
        });

        if (this.enderecosUsuarioRemovidos.length > 0) {
            this._usuarioService.removerEnderecosUsuarioHttp(this.enderecosUsuarioRemovidos)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }

        if (this.enderecosUsuarioInseridos.length > 0) {
            this._usuarioService.cadastrarEnderecosUsuarioHttp(this.enderecosUsuarioInseridos)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }

        if (this.enderecosUsuarioAtualizados.length > 0) {
            this._usuarioService.atualizarEnderecosUsuarioHttp(this.enderecosUsuarioAtualizados)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }
    }

    receberTelefone(telefone: Telefone): void {
        const telefoneUsuario = new TelefoneUsuario(telefone);
        telefoneUsuario.alterado = true;
        this.usuario.telefonesUsuario.push(telefoneUsuario);
    }

    receberEndereco(endereco: Endereco): void {
        const enderecoUsuario = new EnderecoUsuario(endereco);
        enderecoUsuario.alterado = true;
        this.usuario.enderecosUsuario.push(enderecoUsuario);
    }

    atualizarTelefone(telefone: Telefone): void {
        for (let i = 0; i < this.usuario.telefonesUsuario.length; i++) {
            const telefoneUsuario = this.usuario.telefonesUsuario[i];
            if (telefone.idTelefone === undefined) {
                if (i === telefone.index) {
                    telefoneUsuario.alterado = true;
                    telefoneUsuario.telefone = telefone;
                    break;
                }
            } else {
                if (telefoneUsuario.telefone.idTelefone === telefone.idTelefone) {
                    telefoneUsuario.alterado = true;
                    telefoneUsuario.telefone = telefone;
                    break;
                }
            }
        }
    }

    alterarSenha(): void {
        this._authService.changePassword(this.usuario.email).then(() => {
            this.confirmationService.confirm({
                rejectVisible: false,
                message: 'E-mail de redefini\u00e7\u00e3o de senha enviado',
                accept: () => { },
                reject: () => {
                }
            });
        });
    }

    atualizarEndereco(endereco: Endereco): void {
        for (let i = 0; i < this.usuario.enderecosUsuario.length; i++) {
            const enderecoUsuario = this.usuario.enderecosUsuario[i];
            if (endereco.idEndereco === undefined) {
                if (i === endereco.index) {
                    enderecoUsuario.alterado = true;
                    enderecoUsuario.endereco = endereco;
                    break;
                }
            } else {
                if (enderecoUsuario.endereco.idEndereco === endereco.idEndereco) {
                    enderecoUsuario.alterado = true;
                    enderecoUsuario.endereco = endereco;
                    break;
                }
            }
        }
    }

    removerTelefoneUsuario(telefoneUsuario: TelefoneUsuario): void {
        if (this.MODO === this.ATUALIZAR) {
            if (telefoneUsuario.idTelefoneUsuario !== undefined) {
                this.telefonesUsuarioRemovidos.push(telefoneUsuario);
            }
        }
        const index = this.usuario.telefonesUsuario.indexOf(telefoneUsuario);
        this.usuario.telefonesUsuario.splice(index, 1);
    }

    removerEnderecoUsuario(enderecoUsuario: EnderecoUsuario): void {
        if (this.MODO === this.ATUALIZAR) {
            if (enderecoUsuario.idEnderecoUsuario !== undefined) {
                this.enderecosUsuarioRemovidos.push(enderecoUsuario);
            }
        }
        const index = this.usuario.enderecosUsuario.indexOf(enderecoUsuario);
        this.usuario.enderecosUsuario.splice(index, 1);
    }

    onFileChanged(event): void {
        this.foto = event.target.files[0];
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/usuario/cadastro-usuario/cadastro-usuario.component.ts